<template>
    <div>
        <DataTable ref="userReportsTable" :value="userReports" :lazy="true"
                   :loading="loading" class=""
                   :responsiveLayout="isMobile() ? 'stack' : 'scroll'" style="padding-bottom: 50px;"
        >
            <Column header="Adres zgłoszenia"
                    :style="isMobile() ? 'max-width: 1000px;' : 'min-width: 400px; max-width: 1000px;'">
                <template #body="slotProps">
                    {{ computedAddress(slotProps.data) }}
                </template>
            </Column>
            <Column header="Data zgłoszenia"
                    :style="isMobile() ? 'max-width: 1000px;' : 'min-width: 400px; max-width: 1000px;'">
                <template #body="slotProps">
                    {{ slotProps.data.date }}
                </template>
            </Column>
            <template #loading>
                Ładowanie zgłoszeń użytkownika. Proszę czekać.
            </template>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
    import {isMobile} from "@tenrok/vue3-device-detect";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import {
        getCallNetReports as getUserReports,
    } from "@/swagger/vue-api-client";
    import {TimeUtils} from "@/utils/TimeUtils";

    export default {
        name: "UserReportsTable",

        data() {
            return {
                loading: false,
                userReports: [],
            };
        },

        mounted() {
            this.onPage();
            document.querySelectorAll("table thead tr th").forEach((th) => {
                th.setAttribute("scope", "col");
            });
        },

        methods: {
            isMobile() {
                return isMobile;
            },

            async onPage() {
                this.loading = true;

                await getUserReports({timePeriod: "PT24H"})
                    .then((response) => {
                        response.data.items.forEach((item) => {
                            item.date = new Date(item.date).toLocaleString("pl-PL", TimeUtils.options);
                            this.userReports.push(item);
                        });
                    });

                this.loading = false;
            },

            computedAddress(data) {
                return (data.streetType ? (data.streetType + " ") : "") + data.streetName + " " + data.residenceNumber;
            },
        },

        components: {
            Column,
            DataTable,
        },
    };
</script>

<style lang="less">
@import "../../../components/assets/less/datatable.less";
@import "../../assets/less/eon-table.less";
@import "../../../assets/theme/variable.less";
</style>
